import { memo, useEffect, useRef, useState } from "react";
import Loading from "src/components/Loading";
import { useGatheringStore } from "src/contexts/GatheringContext";
import Photo404 from "src/screens/(error)/Photo404";
import useGatheringTopPhotos from "src/screens/(internal)/(GatheringHome)/GatheringHome/hooks/useGatheringTopPhotos";
import PhotoDetailContent from "../PhotoDetailContent";

const PhotoDetailTopDataManager = ({ initialPhotoId }: { initialPhotoId: string }) => {
	const gatheringId = useGatheringStore((state) => state.gatheringId);
	const { topPhotos, queryLoading } = useGatheringTopPhotos({
		gatheringId,
	});

	const [hasInitialKey, setHasInitialKey] = useState(() =>
		topPhotos.some((photo) => photo.photoId === initialPhotoId),
	);
	const prevHasInitialKey = useRef(false);
	useEffect(() => {
		const hasInitialKey = topPhotos.some((photo) => photo.photoId === initialPhotoId);
		if (hasInitialKey !== prevHasInitialKey.current) {
			prevHasInitialKey.current = hasInitialKey;
			setHasInitialKey(hasInitialKey);
		}
	}, [topPhotos, initialPhotoId]);

	if (!hasInitialKey) {
		return queryLoading ? <Loading variant="Screen" /> : <Photo404 />;
	}
	return <PhotoDetailContent photoId={initialPhotoId} photos={topPhotos} />;
};
export default memo(PhotoDetailTopDataManager);
